import logoImage from '../../imagens/logo10224_1024_transparente.png';
import warehouseImage from '../../imagens/carregamento.png';
import conectorImage from '../../imagens/conector.png';
import etiquetandoAppImage from '../../imagens/etiquetandoApp.jpg';
import impressaoIndividualImage from '../../imagens/impressao_individual.png';
import localizarVolumesImage from '../../imagens/localizar_volumes.png';

export const brand = {
  appName: 'EtiquetandoApp',
  companyName: 'Arco Tech Sistemas',
  logoImage,
  whatsappUrl: 'https://wa.me/5547997026699'
};

export const studioUrl = '/login';

export const topNav = [
  { label: 'EtiquetandoApp', href: '/' },
  { label: 'Recursos', href: '#features' },
  { label: 'Studio', href: studioUrl }
];

export const featureCards = [
  {
    title: 'Automatização',
    description:
      'Dê mais agilidade às tarefas manuais e otimize o processo de etiquetação com eficiência.'
  },
  {
    title: 'Flexibilidade',
    description: 'Atende tanto grandes transportadoras quanto pequenas empresas.'
  },
  {
    title: 'Facilidade de Uso',
    description:
      'Disponível no ambiente do cliente ou diretamente no terminal, com impressão de todos os volumes ou apenas os volumes selecionados.'
  }
];

export const solutionStats = [
  {
    value: '100%',
    label: 'compatibilidade com impressoras térmicas'
  },
  {
    value: '3 seg',
    label: 'tempo médio para impressão de etiqueta individual'
  },
  {
    value: '50+',
    label: 'formatos de etiquetas disponíveis. Customizamos suas etiquetas'
  },
  {
    icon: 'printer',
    label: 'compatibilidade com impressões via navegador'
  }
];

export const solutionSlides = [
  {
    title: 'impressão Individual',
    description:
      'Imprima etiquetas individuais, com código de barras ou sem, de forma rápida e eficiente.',
    image: impressaoIndividualImage,
    mediaFit: 'cover',
    mediaPosition: 'center center',
    accent: '#3b82f6',
    overlay: 'linear-gradient(135deg, rgba(37, 99, 235, 0.72), rgba(30, 64, 175, 0.72))'
  },
  {
    title: 'Agilidade no seu Hub',
    description:
      'Gere várias etiquetas de uma vez, reduzindo retrabalho e acelerando a Expedição.',
    image: warehouseImage,
    mediaFit: 'cover',
    mediaPosition: 'center center',
    accent: '#f97316',
    overlay: 'linear-gradient(135deg, rgba(249, 115, 22, 0.72), rgba(194, 65, 12, 0.72))'
  },
  {
    title: 'On-Board Mobile',
    description:
      'Use o aplicativo Android para imprimir de onde a operação acontece, direto na linha de produção.',
    image: etiquetandoAppImage,
    mediaFit: 'contain',
    mediaPosition: 'center center',
    accent: '#22c55e',
    overlay: 'linear-gradient(135deg, rgba(34, 197, 94, 0.72), rgba(21, 128, 61, 0.72))'
  },
  {
    title: 'Localização Inteligente',
    description: 'Não perca tempo procurando volumes no terminal.',
    image: localizarVolumesImage,
    mediaFit: 'contain',
    mediaPosition: 'center center',
    accent: '#8b5cf6',
    overlay: 'linear-gradient(135deg, rgba(139, 92, 246, 0.72), rgba(91, 33, 182, 0.72))'
  },
  {
    title: 'Integração com ERP',
    description:
      'Busca direta na sua base de dados (se disponível), sem integrações complicadas.',
    image: conectorImage,
    mediaFit: 'contain',
    mediaPosition: 'center center',
    accent: '#0f766e',
    overlay: 'linear-gradient(135deg, rgba(13, 148, 136, 0.72), rgba(15, 118, 110, 0.72))'
  }
];

export const downloadCards = [
  {
    title: 'EtiquetandoApp Print',
    description: 'Software de impressão para Windows.',
    href: '/downloads/Etiquetando_print.exe',
    label: 'Baixar para Windows',
    tone: 'blue'
  },
  {
    title: 'EtiquetandoApp Mobile',
    description: 'Aplicativo Android para impressão on-board.',
    href: 'https://play.google.com/store/apps/details?id=com.etiquetandoapp.pro',
    label: 'Baixar para Android',
    tone: 'green'
  },
  {
    title: 'EtiquetandoApp Micro Serviço',
    description: 'Micro serviço para integração com ERP.',
    href: 'https://apps.microsoft.com/detail/9MVXMG84D7KZ?hl=pt-br&gl=BR&ocid=pdpshare',
    label: 'Baixar para Windows Desktop',
    tone: 'blue'
  }
];

export const footerProducts = [
  { label: 'EtiquetandoApp', href: '#' },
  { label: 'PoliStock', href: 'https://polistock.com.br', external: true },
  { label: 'Arco Barber', href: '#' }
];
